import React from "react";

import {
  Typography,
  Modal,
  CircularProgress,
  Button,
  Box,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import MainButton from "../../components/SmallComponents/MainButton";

import "./styles.css";

export default function CustomModal({
  maxWidth = 1027,
  bottomButtonSumbitText,
  bottomButtonSumbitIcon,
  bottomButtonCancelText = "cancelar",
  hideSecondaryButton = false,
  loading,
  title,
  customTitle,
  handleSubmit,
  open = false,
  handleClose,
  width = "100%",
  bodyWrapperStyle = {},
  bodyComponent,
  mainButtonColor = "primary",
  bottomButtonsOrientation = "horizontal",
  modalClass = "",
}) {
  const Header = () => (
    <div className="custom-modal-header">
      {customTitle ? (
        customTitle
      ) : (
        <Typography component="h4" className="left-border my-1">
          {title}
        </Typography>
      )}
      {handleClose && (
        <IconButton
          onClick={handleClose}
          children={<CloseIcon color="secondary" />}
          className="modal-close-button"
        />
      )}
    </div>
  );

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{ maxWidth: maxWidth, width: width }}
          className={"custom-modal " + modalClass}
        >
          <Header />

          <div className="custom-modal-body">
            <div className="custom-modal-content" style={bodyWrapperStyle}>
              {bodyComponent}
            </div>

            <div
              className="buttons-bottom"
              style={{
                flexDirection:
                  bottomButtonsOrientation === "vertical" ? "column" : "row",
                gap: bottomButtonsOrientation === "vertical" ? 8 : 20,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {!!bottomButtonSumbitText && (
                <Button
                  onClick={handleSubmit}
                  disabled={loading}
                  className="main-button-modal px-4 py-2 "
                  color={mainButtonColor}
                  children={
                    loading ? (
                      <CircularProgress
                        style={{ width: 26, color: "white", height: 26 }}
                      />
                    ) : (
                      bottomButtonSumbitText
                    )
                  }
                  startIcon={!loading && bottomButtonSumbitIcon}
                  variant="contained"
                  disabled={loading}
                />
              )}
              {!hideSecondaryButton && (
                <Button
                  variant="text"
                  color="secondary"
                  className="px-4 py-2"
                  onClick={handleClose}
                  disabled={loading}
                >
                  {bottomButtonCancelText}
                </Button>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
